import { gql, TypedDocumentNode } from "@apollo/client";

import {
  CreateTeamMutation,
  CreateTeamMutationVariables,
} from "./CreateTeam.generated";

const CREATE_TEAM: TypedDocumentNode<
  CreateTeamMutation,
  CreateTeamMutationVariables
> = gql`
  mutation createTeam(
    $teamName: String!
    $location: String
    $createdAt: DateTime
    $orgUuid: String
  ) {
    createTeam(
      teamName: $teamName
      location: $location
      createdAt: $createdAt
      orgUuid: $orgUuid
    ) {
      ok
      teamUuid
    }
  }
`;

export default CREATE_TEAM;
